/* __next_internal_client_entry_do_not_use__ Wrapper auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { useShowDeferredContent } from "@faire/web--source/common/deferredRender";
import React from "react";
import { TopOfPageContentWrapper } from "../../../Wrapper";
import { LightweightWrapper } from "./LightweightWrapper";
export var Wrapper = function(param) {
    var children = param.children;
    var showDeferredContent = useShowDeferredContent();
    return showDeferredContent ? /*#__PURE__*/ _jsx(TopOfPageContentWrapper, {
        children: children
    }) : /*#__PURE__*/ _jsx(LightweightWrapper, {
        children: children
    });
};
